import { RouteRecordRaw } from "vue-router";

const spellingRoutes: RouteRecordRaw[] = [
  {
    path: "/spelling/rule/:spellingRuleId?/:ruleName?",
    name: "SpellingLevel2",
    component: () => import("../views/spelling/SpellingRuleView.vue"),
  },
  {
    path: "/spelling-rule/:spellingRuleId?/:ruleName?",
    name: "SpellingLevel",
    component: () => import("../views/spelling/SpellingRuleView.vue"),
  },
  {
    path: "/spelling/test/:testId?",
    name: "SpellingTest",
    component: () => import("../views/spelling/SpellingTestView.vue"),
  },
  {
    path: "/spelling/tricky-words",
    name: "TrickyWordsTest",
    component: () => import("../views/spelling/SpellingTrickyWordsView.vue"),
  },
  {
    path: "/spelling/word-list/:wordListId",
    name: "WordList",
    component: () => import("../views/spelling/SpellingWordListView.vue"),
  },
  {
    path: "/spelling/word-lists",
    name: "WordLists",
    component: () => import("../views/spelling/IndividualWordListsView.vue"),
  },
  {
    path: "/spelling/all-words",
    name: "AllWords",
    component: () => import("../views/spelling/AllWordsView.vue"),
  },
];

export default spellingRoutes;
